
import axios from "axios";
import {getSign} from "virsical-sign";

export const ZOOM_FACTOR = 1.01;
export const DEFAULT_WIDTH = 1920; // 缺省宽度
export const DEFAULT_HEIGHT = 1080; // 缺省高度
export const DEFAULT_BACKGROUND = "#ddd"; // 缺省背景色
export const DEFAULT_SVGBACKGROUND = "#fff"; // 缺省svg背景色
export const COLOR_DEFAULT = "#999"; // 缺省颜色
export const COLOR_SELECTED = "#2a688d"; // 选中颜色
export const PATH_STYLE = {
    animation: "dash 5s linear infinite",
    stroke: "#00ba00",
    strokeWidth: "6px",
    fill: "transparent",
    opacity: 1,
};

export const PATH_STYLE_EX = {
    animation: "dash 5s linear infinite",
    stroke: "#CE3AC2",
    strokeWidth: "6px",
    fill: "transparent",
    opacity: 1,
};

// 判断终端是否支持 touch 事件, true 支持， false 不支持
export const HAVE_TOUCH_EVENT = document.body.ontouchstart !== undefined;

export const path = (defaultPath) => {

    let pathNew = {};
    pathNew['/virsical-map'] = 'virsical-map';
    pathNew[`/${defaultPath}virsical-map`] = `${defaultPath}virsical-map`;

    return pathNew;
};

export const urlSign = (newUrl, token, SING_KEY, defaultPath) => {
    // 开始签名
    //  取第二个 '/' 前的字符
    let restfulPath = newUrl.substring(0, newUrl.indexOf("/", 1));
    if (newUrl && newUrl.includes(`/${defaultPath}`)) {
        restfulPath = newUrl.substring(
            0,
            newUrl.indexOf("/", newUrl.indexOf("/", 1) + 1)
        );
    }
    let signPath = newUrl;

    let pathNew = path(defaultPath);

    // 判断url中如果包含restful前缀，需要清除，签名用
    if (Object.prototype.hasOwnProperty.call(pathNew, restfulPath)) {
        signPath = newUrl.replace(restfulPath, "");
    }
    // 生成签名用的时间戳
    const timestamp = new Date().getTime();

    // 获取token
    const relToken = token.substring(7) || "";
    // 地图服务只签名get请求
    // signatureKey 不等于 M3n6hK 时，header 改为 vsk-sign
    const signKey = sessionStorage.getItem('token_sign') ? sessionStorage.getItem('token_sign') : SING_KEY;
    const signHeaderKey = sessionStorage.getItem('token_sign') ? "vsk-sign" : "vsk-signature";
    return {
        [signHeaderKey]: getSign(signPath, relToken, signKey, timestamp),
        test: "test",
        "vsk-timestamp": timestamp,
    };
};

export const customGet = (
    url,
    signatureKey,
    restfulSignature,
    token,
    requestPrefix,
    defaultPath
) => {
    let headers = {Authorization: token, "vsk-auth": token};
    if (signatureKey && restfulSignature) {
        headers = {...headers, ...urlSign(url, token, signatureKey, defaultPath)};
    }
    return axios.get(requestPrefix + url, {headers: {...headers}});
};


// 排序
export const compare = (prop1, prop2) => {
    return function sort(a, b) {
        const value1 = a[prop1];
        const value2 = b[prop1];

        if (value1 === value2) {
            return a[prop2] - b[prop2];
        }
        return value1 - value2;
    };
};

// 两个数组的对称差
export const findAndCombineDifferences = (arr1, arr2) => {
    // 创建两个Set用于快速查找
    const set1 = new Set(arr1.map(item => item.mapElementId));
    const set2 = new Set(arr2.map(item => item.mapElementId));

    // 找出arr1中有但arr2中没有的元素
    const diffArray1 = arr1.filter(item => !set2.has(item.mapElementId));

    // 找出arr2中有但arr1中没有的元素
    const diffArray2 = arr2.filter(item => !set1.has(item.mapElementId));

    // 合并两个差异结果
    const combinedDiff = [...diffArray1, ...diffArray2];

    return combinedDiff;
}


export const parseColorWithAlpha = (color)  => {
    // 验证格式
    if (typeof color === 'string' && color.startsWith('#') && color.length === 9) {
        // 截取 RGB 和 Alpha
        const rgbHex = '#' + color.slice(1, 7); // 例如：#3c70e5
        const alphaHex = color.slice(7, 9);     // 例如：b8

        // Alpha 转十进制并归一化
        const alphaDecimal = parseInt(alphaHex, 16) / 255;
        const alphaFixed = parseFloat(alphaDecimal.toFixed(2));

        // 返回对象
        return {
            original: color,
            rgbHex: rgbHex,         // 现在是带 # 的格式
            alphaHex: alphaHex,
            alphaDecimal: alphaFixed
        };
    }

    return {
        rgbHex: null,
        alphaDecimal: null
    };
}

/**
 * 限制平移范围，确保视图中心点不超出地图边界（带边界缓冲）
 * @param {Object} value - 包含平移和视图参数的对象
 * @param {number} value.e - X轴平移量（矩阵中的e值）
 * @param {number} value.f - Y轴平移量（矩阵中的f值）
 * @param {number} value.viewerWidth - 视图宽度
 * @param {number} value.viewerHeight - 视图高度
 * @param {number} centerX - 视图中心点X坐标（相对于视图左上角）
 * @param {number} centerY - 视图中心点Y坐标（相对于视图左上角）
 * @param {number|boolean} panBoundary - 边界限制参数
 *   - false: 不限制边界，返回原始值
 *   - 具体数值: 使用 centerX/panBoundary 和 centerY/panBoundary 作为边界缓冲值
 *     确保地图的 (panBoundary-1)/panBoundary 在可视窗口内
 *   - undefined (默认): 使用原有限制方式（bufferX = centerX/2, bufferY = centerY/2）
 * @returns {{e: number, f: number}} 限制后的平移值
 *
 * @description
 * 平移边界限制规则（带缓冲）：
 * - e 的取值范围：minE < e < maxE
 * - f 的取值范围：minF < f < maxF
 *
 * 其中：
 * - bufferX = centerX / panBoundary
 * - bufferY = centerY / panBoundary
 * - minE = -(centerX + (centerX - bufferX)) = -2*centerX + bufferX
 * - maxE = viewerWidth - bufferX
 * - minF = -(centerY + (centerY - bufferY)) = -2*centerY + bufferY
 * - maxF = viewerHeight - bufferY
 *
 * @example
 * // 假设 viewerWidth = 800, viewerHeight = 600, centerX = 400, centerY = 300
 * // panBoundary = 10 时，bufferX = 40, bufferY = 30
 * // 则 e 的范围：-(400 +360) = -760 到 800 - 40 = 760
 * // 则 f 的范围：-(300 + 270) = -570 到 600 - 30 = 570
 * // 这确保了地图的 9/10 在可视窗口内
 * const result = clampPanTranslation(
 *   { e: 0, f: 0, viewerWidth: 800, viewerHeight: 600 },
 *   400, 300, 10
 * );
 *
 * @example
 * // 不限制边界
 * const result = clampPanTranslation(
 *   { e: 500, f: 200, viewerWidth: 800, viewerHeight: 600 },
 *   400, 300, false
 * );
 *
 * @example
 * // 默认行为（panBoundary = undefined）
 * // bufferX = 200, bufferY = 150
 * // e 的范围：-(400 + 200) = -600 到 800 - 200 = 600
 * const result = clampPanTranslation(
 *   { e: 0, f: 0, viewerWidth: 800, viewerHeight: 600 },
 *   400, 300
 * );
 */
export const clampPanTranslation = (value, centerX, centerY, panBoundary) => {
    const { e, f, viewerWidth, viewerHeight } = value;

    // panBoundary 为 false 时，不限制边界
    if (panBoundary === false) {
        return { e, f };
    }

    // 计算边界缓冲值
    let bufferX, bufferY;
    if (panBoundary !== undefined) {
        // panBoundary 为具体数值时，使用 SVGWidth/panBoundary 作为边界缓冲值
        // 这确保了地图的 (panBoundary-1)/panBoundary 在可视窗口内
        bufferX = centerX / panBoundary;
        bufferY = centerY / panBoundary;
    } else {
        // 默认：使用 centerX/2 和 centerY/2 作为边界缓冲值
        bufferX = centerX / 2;
        bufferY = centerY / 2;
    }

 //   window.console.log(e,f, bufferX,bufferY, centerX, centerY, '333333')
    // 更新边界限制规则：
    // e > -(centerX + bufferX) 且 e < (viewerWidth - centerX + bufferX)
    const minE = -(centerX + (centerX - bufferX));
    const maxE = viewerWidth - centerX + (centerX - bufferX);

    // f > -(centerY + bufferY) 且 f < (viewerHeight - centerY + bufferY)
    const minF = -(centerY + (centerY - bufferY));
    const maxF = viewerHeight - centerY + (centerY - bufferY);

    // 应用限制
    const clampedE = Math.max(minE, Math.min(maxE, e));
    const clampedF = Math.max(minF, Math.min(maxF, f));

    return {
        e: clampedE,
        f: clampedF
    };
};